import { useState } from 'react';
import { StyledBroadsiderInventorySelector } from './BroadsiderInventorySelector.styled';
import { BroadsiderInventoryItem, ExploreItems } from '../';
import { openUrl } from '../../utils';
import { AppContext } from '../../providers/AppContext';
import { useContext } from 'react';

const BroadsiderInventorySelector = ({ slot }) => {
  const { equipItem } = useContext(AppContext);
  const onItemClick = (item) => {
    equipItem(item, !item.isEquipped());
  };

  return (
    <StyledBroadsiderInventorySelector>
      <div className='broadsider-inv-selector-content-wrapper'>
      <div className='broadsider-inv-selector-content'>
        <div className='broadsider-inv-selector-title-holder'>
          <div className='broadsider-inv-selector-title-stub-short' />
          <div className='broadsider-inv-selector-logo-and-title'>
            <img className='broadsider-inv-selector-logo' src={slot.logo} />
            <div className='broadsider-inv-selector-title'>{slot.type}</div>
          </div>
          <div className='broadsider-inv-selector-title-stub-long' />
          <div className='broadsider-inv-selector-title-number'>{slot.options.length}</div>
          <div className='broadsider-inv-selector-title-stub-short' />
        </div>
        <div className='broadsider-inv-selector-holder'>
          <div className='broadsider-inv-selector-items'>
            {slot.options.map((o, index) => (<BroadsiderInventoryItem key={`inv-item-${index}`} item={o} isSelected={slot.equipped === o} onClick={() => onItemClick(o)}/>))}
	    <ExploreItems isCategory={false} slot={slot} onClick={() => openUrl(slot.exploreUrl)} />
          </div>
        </div>
      </div>
      </div>
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-tl' />
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-tr' />
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-bl' />
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-br' />
    </StyledBroadsiderInventorySelector>
  )
};

export default BroadsiderInventorySelector;
